import { render } from "./DateBadge.vue?vue&type=template&id=694b4aaf"
import script from "./DateBadge.vue?vue&type=script&lang=js"
export * from "./DateBadge.vue?vue&type=script&lang=js"

import "./DateBadge.vue?vue&type=style&index=0&id=694b4aaf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__